import { fromBasket } from '@agent/core/basket';
import { BasketStoreModel } from '@agent/core/basket/basket.model';
import { select } from '@commons/util/utilities/store/entity.select';
import { OperatorFunction, pipe } from 'rxjs';

import { ChannelType } from '@contact/upgrade';

import { MailChannelModel, QueryFilterModel, QuickFilterModel } from './mail-basket.model';

export function selectMailBasket(): OperatorFunction<BasketStoreModel, MailChannelModel> {
  return fromBasket.selectChannelByType(ChannelType.MAIL);
}

export function selectQueryFilters(): OperatorFunction<BasketStoreModel, QueryFilterModel> {
  return pipe(
    selectMailBasket(),
    select(s => s.queryFilters)
  );
}

export function selectQuickFilters(): OperatorFunction<BasketStoreModel, QuickFilterModel> {
  return pipe(
    selectMailBasket(),
    select(s => s.quickFilters)
  );
}
